import { render } from "./ImageViewer.vue?vue&type=template&id=027f2d7e&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=027f2d7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-027f2d7e"

export default script